module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("注册生意专家")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "input-groups"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('i', {
    staticClass: "icon phone-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "输入手机号码作为登录账号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('i', {
    staticClass: "icon password-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "设置登录密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('i', {
    staticClass: "icon password-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "code-btn",
    attrs: {
      "disabled": _vm.codeWorking
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.codeText))])])]), _vm._v(" "), _c('c-button', {
    staticClass: "weui-overwrite-btn",
    nativeOn: {
      "click": function($event) {
        _vm.submitSignupProcess($event)
      }
    }
  }, [_vm._v("立即注册")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cbc8c66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/signup/index.vue
// module id = 386
// module chunks = 0